const Row = ({ items, separator }) => (
  <div className="flex shrink-0 items-center">
    {items.map((t, i) => (
      <span key={i} className="flex items-center whitespace-nowrap">
        <span className="mx-8 md:mx-12">{t}</span>
        <span className="opacity-40 text-[0.6em]">{separator}</span>
      </span>
    ))}
  </div>
);

const Marquee = ({ items, className = '', fast = false, separator = '●' }) => (
  <div className={`relative flex overflow-hidden ${className}`} data-testid="editorial-marquee">
    <div className={`flex ${fast ? 'animate-marquee-fast' : 'animate-marquee'}`}>
      <Row items={items} separator={separator} />
      <Row items={items} separator={separator} />
    </div>
  </div>
);

export default Marquee;
